
import { Button, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/system";
import { customPalette } from "shared/palettes";

export const ContainerStyle = styled(Container)`
  height: 100%;
  display: flex;
  align-items: center;
  background: ${customPalette.default};
  flex-direction: column;
`;

export const ActionButton = styled(Button)(({ theme, colorname }) => ({
  borderRadius: 16,
  padding: "10px 0",
  fontWeight: "bold",
  boxShadow: "none",
  "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.1)" },
}));

export const GamePaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
  borderRadius: 24,
  textAlign: "center",
  transition: "all 0.3s ease",
  border: active
    ? `2px solid ${theme.palette.primary.main}`
    : "2px solid transparent",
  boxShadow: active ? "0 8px 24px rgba(0,0,0,0.12)" : theme.shadows[2],
  height: "100%",
  width: "100%",
}));
